import { StyleSheet } from "react-native";
import type { Palette } from "@heraion/shared";

// Styles for the Select control (the 3b editor's sole surviving UI piece —
// the matrix tree was removed 2026-06-12, superseded by ProgramComposer).
// Dark/light resolved once from the palette by the host and threaded down.
export function makeEditorStyles(p: Palette) {
  return StyleSheet.create({
    select: {
      minHeight: 44,
      borderWidth: 1,
      borderColor: p.border,
      borderRadius: 10,
      paddingHorizontal: 12,
      justifyContent: "center",
      backgroundColor: p.surface,
    },
    selectText: { color: p.ink, fontSize: 14 },
    selectPlaceholder: { color: p.ink3, fontSize: 14 },
    modalScrim: {
      flex: 1,
      backgroundColor: "rgba(0,0,0,0.5)",
      justifyContent: "center",
      padding: 20,
    },
    modalSheet: {
      backgroundColor: p.surface,
      borderRadius: 14,
      borderWidth: 1,
      borderColor: p.border,
      maxHeight: "80%",
      overflow: "hidden",
    },
    modalSearch: {
      minHeight: 48,
      borderBottomWidth: 1,
      borderBottomColor: p.border,
      paddingHorizontal: 14,
      color: p.ink,
      fontSize: 15,
    },
    option: {
      minHeight: 48,
      paddingHorizontal: 16,
      justifyContent: "center",
      borderBottomWidth: 1,
      borderBottomColor: p.border,
    },
    optionOn: { backgroundColor: p.surface2 },
    optionText: { color: p.ink, fontSize: 15 },
    optionTextOn: { color: p.brand500, fontWeight: "700" },
  });
}

export type EditorStyles = ReturnType<typeof makeEditorStyles>;
